/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Select_Original_FailedInputs */



/**
* | output |
* | --- |
* | "Error selecting original media file" |
*
* @param {Audio_Embed_Export_Select_Original_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_select_original_failed = /** @type {((inputs?: Audio_Embed_Export_Select_Original_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Select_Original_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreur lors de la sélection du fichier multimédia d'origine")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Auswählen der Originalmediendatei")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errore durante la selezione del file multimediale originale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ошибка при выборе исходного медиафайла.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al seleccionar el archivo multimedia original")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择原始媒体文件时出错")
	if (locale === "ja") return /** @type {LocalizedString} */ ("元のメディアファイルの選択中にエラーが発生しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मूल मीडिया फ़ाइल का चयन करने में त्रुटि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Erro ao selecionar o arquivo de mídia original")
	return /** @type {LocalizedString} */ ("Error selecting original media file")
});